import { DEVICE_PREFIX, defaultRequest } from '@/config/api'
import axios from 'axios'

const axiosDeviceInstance = axios.create({
    baseURL: DEVICE_PREFIX || window.location.origin,
    ...defaultRequest
})

export default axiosDeviceInstance
